export default "__VITE_ASSET__iGRW_QFo__"